/**
 * @generated SignedSource<<9cc4eba514a0b041b15c69b3af79a9a3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BundleStatus = "CANCELLED" | "COLLECTED" | "CONFIRMED" | "FORMING" | "PARTIALLY_COLLECTED" | "READY_FOR_PICKUP" | "%future added value";
export type HubService = "CLICK_N_COLLECT" | "INSTANT_BUY" | "LOCK_B2B" | "LOCK_B2C" | "ONEDELIVERY" | "RAFFLE" | "SHOP_N_COLLECT" | "%future added value";
export type PackageStatus = "COLLECTED" | "IN_COMPARTMENT" | "IN_TRANSIT_TO_HUB" | "IN_TRANSIT_TO_WAREHOUSE" | "IN_WAREHOUSE" | "%future added value";
export type bundleOneDeliveryQuery$variables = {
  id: string;
  statuses: ReadonlyArray<BundleStatus>;
  userId: string;
};
export type bundleOneDeliveryQuery$data = {
  readonly activeBundles: {
    readonly nodes: ReadonlyArray<{
      readonly createdAt: any;
      readonly id: string;
    }>;
  };
  readonly bundle: {
    readonly destinationHubs: ReadonlyArray<{
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly services: ReadonlyArray<HubService>;
      } | null | undefined;
    }>;
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly city: string;
        readonly id: string;
        readonly name: string;
        readonly street: string;
      } | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly packages: {
      readonly nodes: ReadonlyArray<{
        readonly creditId: string | null | undefined;
        readonly id: string;
        readonly reservation: {
          readonly id: string;
          readonly space: {
            readonly frame: string;
            readonly id: string;
            readonly position: number;
          };
        } | null | undefined;
        readonly status: PackageStatus;
        readonly updatedAt: any;
      }>;
      readonly totalCount: number;
    };
    readonly status: BundleStatus;
    readonly userId: string;
    readonly warehouse: {
      readonly city: string;
      readonly id: string;
      readonly name: string;
      readonly postalCode: string;
      readonly street: string;
    };
  };
  readonly creditBalance: {
    readonly available: number;
  };
};
export type bundleOneDeliveryQuery = {
  response: bundleOneDeliveryQuery$data;
  variables: bundleOneDeliveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statuses"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v8 = [
  {
    "alias": "activeBundles",
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "statuses",
            "variableName": "statuses"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "pagination",
        "value": {
          "page": 0,
          "pageSize": 100
        }
      }
    ],
    "concreteType": "BundlePage",
    "kind": "LinkedField",
    "name": "bundles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Bundle",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Bundle",
    "kind": "LinkedField",
    "name": "bundle",
    "plural": false,
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      },
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "hub",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMeta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Warehouse",
        "kind": "LinkedField",
        "name": "warehouse",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postalCode",
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "destinationHubs",
        "plural": true,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMeta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "services",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "pagination",
            "value": {
              "page": 0,
              "pageSize": 1000
            }
          }
        ],
        "concreteType": "PackagePage",
        "kind": "LinkedField",
        "name": "packages",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Package",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creditId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OnedeliveryReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "frame",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "position",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "packages(pagination:{\"page\":0,\"pageSize\":1000})"
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditBalance",
    "kind": "LinkedField",
    "name": "creditBalance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "available",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "bundleOneDeliveryQuery",
    "selections": (v8/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "bundleOneDeliveryQuery",
    "selections": (v8/*:: as any*/)
  },
  "params": {
    "cacheID": "d20d2d12840131a2452952a60f2a20a6",
    "id": null,
    "metadata": {},
    "name": "bundleOneDeliveryQuery",
    "operationKind": "query",
    "text": "query bundleOneDeliveryQuery(\n  $id: UUID!\n  $userId: UUID!\n  $statuses: [BundleStatus!]!\n) {\n  activeBundles: bundles(filter: {userId: $userId, statuses: $statuses}, pagination: {page: 0, pageSize: 100}) {\n    nodes {\n      id\n      createdAt\n    }\n  }\n  bundle(id: $id) {\n    id\n    userId\n    status\n    hub {\n      id\n      meta {\n        id\n        name\n        street\n        city\n      }\n    }\n    warehouse {\n      id\n      name\n      street\n      postalCode\n      city\n    }\n    destinationHubs {\n      id\n      meta {\n        id\n        services\n      }\n    }\n    packages(pagination: {page: 0, pageSize: 1000}) {\n      totalCount\n      nodes {\n        id\n        status\n        creditId\n        updatedAt\n        reservation {\n          id\n          space {\n            id\n            frame\n            position\n          }\n        }\n      }\n    }\n  }\n  creditBalance {\n    available\n  }\n}\n"
  }
};
})();

(node as any).hash = "8db28f843b99cac5f05b442b3c6ca827";

export default node;
